import styled from 'styled-components'
import { parseHtml } from 'helpers/utils'
import FontAwesome from 'react-fontawesome'
import scrollToElement from 'scroll-to-element'
import { Collapse } from 'react-bootstrap'
import {
  FeedbackContainer,
  ContentMailerContainer,
  FavouritesToggle
} from 'containers'
import InlineLoader from 'components/InlineLoader'
import { DeviceNameHOC } from 'hocs'
import MetaData from '../MetaData'

const FaqContainer = styled.li`
  position: relative;
`
const FaqTitle = styled.div`
  padding: 7px 48px 7px 25px;
  font-size: 15px;
  cursor: pointer;

  ul ul ul & {
    padding-left: 50px;
  }
  .fa-caret-down,
  .fa-caret-right {
    margin-right: 5px;
    color: ${(props) =>
      props.active ? 'var(--main-color)' : 'var(--dark-gray)'};
  }

  @media only screen and (max-width: 768px) {
    padding: 7px 48px 7px 0px;
    ul ul ul & { padding-left: 5px; }
  }
`
const FaqContent = styled.div`
  padding-left: 55px;
  margin: 5px 0;
  ul ul ul & { padding-left: 70px; }
  li { list-style: disc; }

  @media only screen and (max-width: 768px) {
    padding-left: 10px;
    ul ul ul & { padding-left: 0px; }
  }
`

const MailIcon = styled.div`
  position: absolute;
  right: 5px;
  top: 4px;
`

const ToggleButton = styled.div`
  position: absolute;
  right: 22px;
  top: 5px;
`

const scrollTo = (e) => {
  scrollToElement(e, { offset: -150, duration: 500 })
}

const Faq = DeviceNameHOC(({ faq, active, handleClick, deviceName }) => (
  <FaqContainer key={faq.PK}>
    <FaqTitle active={active}>
      <span
        onClick={handleClick.bind(
          this,
          'currentFaq',
          faq.PK,
          faq.name,
          faq.phonefk
        )}
      >
        <FontAwesome name={`caret-${active ? 'down' : 'right'}`} />
        {faq.name} {deviceName(faq.phonefk)}
      </span>
    </FaqTitle>

    <ToggleButton>
      <FavouritesToggle
        contentType="faq"
        contentId={faq.PK}
        deviceId={faq.phonefk}
        contentTitle={faq.name}
      />
    </ToggleButton>
    <MailIcon>
      <ContentMailerContainer
        emailBody={faq.val}
        contentId={faq.PK}
        contentType="faqs"
      />
    </MailIcon>

    <Collapse
      in={active}
      mountOnEnter
      unmountOnExit
      onEntered={scrollTo}
      timeout={0}
    >
      <div>
        <FaqContent>
          <div
            className="faq-content"
            dangerouslySetInnerHTML={{ __html: parseHtml(faq.val) }}
          />
          <MetaData id={faq.salesforce_id} date={faq.update_date} />
          <FeedbackContainer contentType="faqs" contentId={faq.PK} />
        </FaqContent>
      </div>
    </Collapse>
  </FaqContainer>
))
const Faqs = ({ faqs, isFetching, handleClick, currentFaq }) => {
  const faqList = faqs.map((faq) => {
    const active = currentFaq === faq.PK
    return (
      <Faq key={faq.PK} faq={faq} active={active} handleClick={handleClick} />
    )
  })

  if (isFetching) {
    return <InlineLoader />
  }

  return <div>{faqList}</div>
}

export default Faqs
